import React from "react";
import Card from "components/card";
import { CATEGORY_ICONS } from "variables/constants"
import Button from "components/button";
import { LuArrowRight } from "react-icons/lu";

const CategoryCard = ({ variant = 'it-support', category }) => {
    const Icon = CATEGORY_ICONS?.[category?.label] || LuArrowRight;
    
    const styles = {
        'it-support': {
            cardClass: "bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 hover:border-blue-300 hover:shadow-lg transition-all overflow-hidden dark-mode-card dark:border-slate-700 dark:hover:border-blue-800",
            gradientClass: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 bg-gradient-to-br from-blue-50 to-cyan-50 pb-4 dark:from-blue-900 dark:to-cyan-900",
            iconClass: "p-2.5 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 text-white"
        },
        'hr-support': {
            cardClass: "bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 hover:border-pink-300 hover:shadow-lg transition-all overflow-hidden dark-mode-card dark:border-slate-700",
            gradientClass: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 bg-gradient-to-br from-pink-50 to-rose-50 pb-4 dark:from-pink-900 dark:to-rose-900",
            iconClass: "p-2.5 rounded-xl bg-gradient-to-br from-pink-500 to-rose-500 text-white"
        },
        'partner-service': {
            cardClass: "bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 hover:border-purple-300 hover:shadow-lg transition-all overflow-hidden",
            gradientClass: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 bg-gradient-to-br from-purple-50 to-indigo-50 pb-4",
            iconClass: "p-2.5 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-500 text-white"
        }
    };
    
    const currentStyle = styles[variant] || styles['it-support'];

    return (
        <Card className={currentStyle.cardClass}>
            <div className={currentStyle.gradientClass}>
                <div className="flex items-center gap-3">
                    <div className={currentStyle.iconClass}>
                        <Icon className="w-5 h-5" />
                    </div>
                    <h4 className="text-[16px] title-text">{category?.label}</h4>
                </div>
            </div>
            <div className="pb-6 p-4">
                <p className="text-[12px] muted-text lowercase mb-3">
                    Common issues and solutions for {category?.label} related problems.
                </p>
                <Button
                    className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all shrink-0 outline-none 
                            border bg-white text-slate-900 h-8 rounded-lg px-3 w-full gap-2 hover:shadow-none hover:bg-slate-100 hover:text-slate-900 dark:bg-white/10 dark:text-white dark:hover:bg-slate-800"
                >
                    View Articles
                    <LuArrowRight className="w-4 h-4" />
                </Button>
            </div>
        </Card>
    );
};

export default CategoryCard;